import { useRef } from 'react';

let lastDialog = 0;

/**
 * Stable ids for one dialog instance's fields. MUI 4 links a TextField's
 * label to its input only through `id`, and several cards or lines can be on
 * screen at once, so each instance gets its own prefix.
 */
export const useFieldIds = (prefix: string) => {
  const base = useRef(`${prefix}-${++lastDialog}`).current;
  return (name: string) => `${base}-${name}`;
};
